import { render, staticRenderFns } from "./refunReviewList.vue?vue&type=template&id=c5a8cdc4&scoped=true"
import script from "./refunReviewList.vue?vue&type=script&lang=js"
export * from "./refunReviewList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5a8cdc4",
  null
  
)

export default component.exports